export * as affiliate from './affiliate'
export * as boardEngagement from './board-engagement'
export * as boardSize from './board-size'
export * as caseForSupport from './case-for-support'
export * as currentRevenue from './current-revenue'
export * as dataAnalyticsAndUsage from './data-analytics-usage'
export * as digitalPresence from './digital-presence'
export * as donorDatabaseManagement from './donor-database-management'
export * as donorLifetimeValue from './donor-lifetime-value'
export * as eventManagement from './event-management'
export * as girlsServed from './girls-served'
export * as givingFrequency from './giving-frequency'
export * as grantWriting from './grant-writing'
export * as lapsedDonors from './lapsed-donors'
export * as majorGiftExperience from './major-gift-experience'
export * as marketingMaterials from './marketing-materials'
export * as newDonors from './new-donors'
export * as onlineSplit from './online-split'
export * as retainedDonors from './retained-donors'
export * as staffCount from './staff-count'
export * as stewardshipPrograms from './stewardship-programs'
export * as totalActiveDonors from './total-active-donors'
